import { ALL_PERMISSION_KEYS } from "./permissionKeys";
import { API_PERMISSION_CODE_TO_APP_KEY, normalizeApiPermissionCode } from "./apiPermissionMap";

/**
 * Builds the app's `Record<permissionKey, boolean>` from GET /users/me `role.permissions`.
 * Unknown API codes are ignored. Every known app key is present (default `false`).
 *
 * @param {unknown} apiCodes
 * @returns {Record<string, boolean>}
 */
export function buildPermissionsFromApiCodes(apiCodes) {
  const out = Object.fromEntries(ALL_PERMISSION_KEYS.map((k) => [k, false]));
  if (!Array.isArray(apiCodes)) {
    return out;
  }
  for (const raw of apiCodes) {
    const code = normalizeApiPermissionCode(raw);
    if (!code) continue;
    const appKey = API_PERMISSION_CODE_TO_APP_KEY[code];
    if (appKey == null || appKey === "") continue;
    if (Array.isArray(appKey)) {
      for (const k of appKey) {
        if (k) out[k] = true;
      }
    } else {
      out[appKey] = true;
    }
  }
  return out;
}
